<template>
  <div id="mobile">
    <VanConfigProvider theme-vars-scope="global">
      <router-view v-slot="{ Component }">
        <keep-alive :include="cacheKeyList">
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </VanConfigProvider>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { cacheKeyList } from '@/utils/h5Cache.js';
import { wxJsSdkInit } from '@/utils/wxJsSdk.js';

const route = useRoute();

</script>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  async beforeRouteEnter(to, from, next) {
    try {
      await wxJsSdkInit();
    } finally {
      next();
    }
  },
});
</script>

<style lang="scss" scoped>
#mobile{
  width: 100%;
  height: 100%; /* 改用百分比，依赖父元素html/body的100%高度 */
  min-height: 100vh; /* 兜底兼容，确保在现代浏览器中生效 */
  box-sizing: border-box; /* 避免padding/border撑开尺寸 */
}
</style>
